import React from 'react';
import PlanDetailsComponent from '../../components/PlanDetailsComponent/PlanDetailsComponent';

function PlanDetailsPage() {
    return <PlanDetailsComponent/>;
}

export default PlanDetailsPage;
